module.exports = __webpack_public_path__ + "img/10-5.e86170c0.png";